export class DartError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "DartError";
    if ("captureStackTrace" in Error) {
      Error.captureStackTrace(this, DartError);
    }
  }
}
